import React from 'react'
import { Button } from 'src/components'
import { Download } from 'src/assets/svg'
import { useStyles } from './styles'

interface Props {
  onExport: () => void
  disabled?: boolean
}

export const GeneticEvaluationHeader: React.FC<Props> = ({ onExport, disabled }) => {
  const styles = useStyles()

  return (
    <div className={styles.geneticEvaluationExportButtonContainer}>
      <Button secondary className={styles.geneticEvaluationButtonExport} disabled={disabled} onClick={onExport}>
        <Download className='icon' />
        Exportar
      </Button>
    </div>
  )
}
